// A coloured tag per file type: PDF red/orange, emails light blue, spreadsheets green, Word blue, photos purple,
// drawings teal, archives grey, links slate.
const GROUPS: { cls: string; exts: string[] }[] = [
  { cls: 'ft-pdf', exts: ['pdf'] },
  { cls: 'ft-mail', exts: ['eml', 'msg', 'mbox'] },
  { cls: 'ft-sheet', exts: ['xlsx', 'xls', 'xlsm', 'csv', 'ods', 'numbers'] },
  { cls: 'ft-doc', exts: ['docx', 'doc', 'rtf', 'odt', 'pages', 'txt'] },
  { cls: 'ft-img', exts: ['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp', 'gif', 'tif', 'tiff', 'bmp'] },
  { cls: 'ft-cad', exts: ['dwg', 'dxf', 'rvt', 'ifc', 'skp', 'fbx', '3ds', 'glb', 'gltf'] },
  { cls: 'ft-zip', exts: ['zip', 'rar', '7z'] },
  { cls: 'ft-slide', exts: ['pptx', 'ppt', 'key'] },
];

export function fileTag(name: string | null | undefined, kind?: string | null): { label: string; cls: string } {
  if (kind === 'link') return { label: 'LINK', cls: 'ft-link' };
  const e = (name ?? '').includes('.') ? (name ?? '').split('.').pop()!.toLowerCase() : '';
  const g = GROUPS.find((x) => x.exts.includes(e));
  return { label: (e || 'file').slice(0, 4).toUpperCase(), cls: g?.cls ?? 'ft-other' };
}
